import React, { useCallback } from 'react';
import { Field } from 'formik';
import _ from 'lodash';
import { Country } from '@tradingblock/types';
import { TextboxField, SelectDropdownField } from './';
import { FormGroup } from '../../basic';
export const AddressField = ({ id, labelPrefix, countryProps, addr1Help, stateProps, field, }) => {
    const { value } = field;
    const country = _.get(value, `${id}.country`);
    const getTextboxFieldProps = useCallback((field) => {
        const fieldProps = {
            component: TextboxField,
            id: `${id}.${field}`,
            defaultLabelId: `address.${field}`,
        };
        if (field === 'state') {
            fieldProps.defaultLabelId = `address.province`;
        }
        if (labelPrefix) {
            return Object.assign({}, fieldProps, { labelPrefix });
        }
        return fieldProps;
    }, [id, labelPrefix]);
    return (React.createElement(React.Fragment, null,
        React.createElement(FormGroup, null,
            React.createElement(Field, Object.assign({ component: SelectDropdownField, id: `${id}.country` }, countryProps, { autoComplete: `${id}.country` }))),
        React.createElement(FormGroup, { help: addr1Help },
            React.createElement(Field, Object.assign({}, getTextboxFieldProps('address1')))),
        React.createElement(FormGroup, null,
            React.createElement(Field, Object.assign({}, getTextboxFieldProps('address2')))),
        React.createElement(FormGroup, null,
            React.createElement(Field, Object.assign({}, getTextboxFieldProps('city')))),
        React.createElement(FormGroup, null,
            (country === Country.UnitedStatesOfAmerica || country === '') && (React.createElement(React.Fragment, null,
                React.createElement(Field, Object.assign({ component: SelectDropdownField, id: `${id}.state` }, stateProps, { autoComplete: 'HEYOOOO' })))),
            country !== Country.UnitedStatesOfAmerica && country !== '' && (React.createElement(React.Fragment, null,
                React.createElement(Field, Object.assign({}, getTextboxFieldProps('state')))))),
        React.createElement(FormGroup, null,
            React.createElement(Field, Object.assign({}, getTextboxFieldProps('postalCode'))))));
};
//# sourceMappingURL=Address.js.map